import { object, string } from 'yup';
import { user } from '@tg/core/components/systems/Form/validations';

export default object().shape({
  officer: user.shape({
    email: string().email(),
    job_title: string().required(),
  }),
});
